/* eslint-disable no-unused-vars */
export enum Constants {
    DEFAULT_SUCCESS_MESSAGE = 'Operación realizada con éxito',
    DEFAULT_INFO_MESSAGE = 'Guardando...',
    DEFAULT_ERROR_MESSAGE = 'Se produjo un error inesperado',
}
